import { createWebHashHistory, createRouter } from 'vue-router'


const routes = [
    {
        path: '/',
        name: 'Main',
        component: () => import('../views/MainView.vue'),
    },
    {
        path: '/Login',
        name: 'Login',
        component: () => import('../views/LoginView.vue'),
    },
    {
        path: '/Register',
        name: 'Register',
        component: () => import('../views/RegisterView.vue'),
    },
    {
        path: '/HowToPlay',
        name: 'HowToPlay',
        component: () => import('../views/HowToUseView.vue'),
    }
]

const router = new createRouter({
    mode: 'hash',
    history: createWebHashHistory(),
    Base: process.env.BASE_URL,
    routes,
})
export default router